export default "__VITE_ASSET__CcCwIWWa__"